import PaymentsTable from './PaymentsTable';

export default PaymentsTable;
